
export class AdminUsuario {
    id: string;
    authID: string;
    displayName: string;
    fullName: string;
    userName: string;
    preferencias: string;
    email: string;
    phoneNumber: string;
    codigoTecnico: string;
    tecnico: boolean;
    validador: boolean;
    gestor: boolean;
    visitador: boolean;
    admin: boolean;
    isActive : boolean;
    
    public constructor() {
        this.id = this.authID = this.displayName = this.fullName = this.userName = this.preferencias = this.email = this.phoneNumber = this.codigoTecnico = '';
        this.tecnico = this.validador = this.gestor = this.visitador = this.admin = false;
        this.isActive = true;
    }
}